import React from "react"
import { motion } from 'framer-motion'
import { useDispatch, useSelector } from "react-redux"
import { setSideBar } from "../Store/Theme/actions";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { HiOutlineQuestionMarkCircle } from "react-icons/hi2";
import { getCurrentEmployee, getEmployeeSopState } from "../Common/sopTracking";
import StaffSopDialog from "./StaffSopDialog";
import NotificationPanel, { BellButton, useNotifications } from "./NotificationPanel";

const isReviewedToday = (tracking) => {
    const today = new Date().toISOString().slice(0, 10)
    return tracking?.stats?.lastReviewedAt?.slice?.(0, 10) === today
}

const TopBar = () => {
    const dispatch = useDispatch()
    const pageTitle = useSelector((state) => state.theme.pageTitle)
    const [showSop, setShowSop] = React.useState(false)
    const [notifOpen, setNotifOpen] = React.useState(false)
    const currentEmployee = React.useMemo(() => getCurrentEmployee(), [])
    const [sopTracking, setSopTracking] = React.useState(() => getEmployeeSopState(currentEmployee.employeeId))
    const employeeInitial = (currentEmployee.displayName || "A").trim().charAt(0).toUpperCase()
    const { notifications, unread, fetch: refreshNotifs, markRead, markAllRead } = useNotifications()

    return (
        <>
            <motion.header className="sticky top-0 z-30 flex flex-col gap-4 border-b border-borderColor bg-white/96 px-6 py-4 backdrop-blur-sm md:flex-row md:items-center md:justify-between lg:px-8" style={{borderBottomColor:'rgba(200,146,10,0.18)'}}>
                <div className="flex items-center gap-3">
                    <button
                        type="button"
                        className="flex h-11 w-11 items-center justify-center rounded-lg border border-borderColor bg-white text-primeColor shadow-soft lg:hidden"
                        onClick={() => dispatch(setSideBar(true))}
                    >
                        <HiOutlineMenuAlt1 className="text-xl" />
                    </button>
                    <div>
                        <h1 className="text-2xl font-semibold text-tColor">{pageTitle || 'Dashboard'}</h1>
                    </div>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                    <button
                        type="button"
                        className="relative inline-flex min-h-[42px] items-center gap-2 rounded-2xl border border-borderColor bg-white px-4 py-2 pr-10 text-sm font-bold text-tColor shadow-soft transition hover:border-primeColor hover:text-primeColor"
                        onClick={() => setShowSop(true)}
                    >
                        <HiOutlineQuestionMarkCircle className="text-base" />
                        SOP
                        <span
                            className={`absolute right-3 top-1/2 h-2.5 w-2.5 -translate-y-1/2 rounded-full ${
                                isReviewedToday(sopTracking) ? "bg-emerald-500" : "bg-amber-500"
                            }`}
                        />
                    </button>

                    {/* Bell notification */}
                    <BellButton unread={unread} onRefresh={refreshNotifs} onClick={() => setNotifOpen(true)} />

                    <div className="hidden text-right md:block">
                        <p className="text-sm font-medium text-tColor">{currentEmployee.displayName}</p>
                        <p className="text-xs text-tpColor">{currentEmployee.email}</p>
                    </div>
                    <div className="flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold" style={{background:'linear-gradient(135deg,#0A1628,#112240)',color:'#F5D264',border:'1.5px solid rgba(200,146,10,0.4)'}}>
                        {employeeInitial || "A"}
                    </div>
                </div>
            </motion.header>

            <StaffSopDialog open={showSop} onClose={() => setShowSop(false)} onTrackingChange={setSopTracking} />
            <NotificationPanel
                open={notifOpen}
                onClose={() => setNotifOpen(false)}
                notifications={notifications}
                unread={unread}
                markRead={markRead}
                markAllRead={markAllRead}
            />
        </>
    )
}

export default TopBar
